import { creditorSagas } from "./Creditor"
import { ManageCreditorSagas } from './ManageCreditors'
import {creditorCaseSagas} from './CreditorCases'
import { selectedCreditorsSagas } from "./SelectedCreditors"


export default [
    ...creditorSagas,
    ...ManageCreditorSagas,
    ...creditorCaseSagas,
    ...selectedCreditorsSagas
]